// replace the user pool region, id, and app client id details
export default {
  REGION: "us-west-2",
  USER_POOL_ID: "us-west-2_6WVdJfXBI",
  USER_POOL_APP_CLIENT_ID: "1nc2gclmqmc49b67ajpok4ifhg",
};
